import {IconName} from "../utils";

export const PATH = {
    HOME: '/',
    LOGIN: '/dang-nhap',
    ONBOARDING: '/onboarding',
    STORE_INFO: '/thong-tin-cua-hang',
    MANAGING_PRODUCT: '/quan-ly-san-pham',
    CREATE_PRODUCT: '/tao-san-pham',
    ADDRESS: '/so-dia-chi',
    SHIPPING_CONFIG: '/cau-hinh-van-chuyen',
    EDIT_PRODUCT: '/chinh-sua-san-pham',
    MANAGING_ORDER: '/quan-ly-don-hang',
    ACCOUNT_SETTING: '/quan-ly-tai-khoan',
    CHANGE_PASSWORD: '/doi-mat-khau',
    SHARE: '/chia-se',
    BUYER_MANAGEMENT_CART_DETAIL: '/quan-ly-don-hang/order',
    NOTIFICATION: '/thong-bao',
}

export const STATUS = {
    STATUS_SHIPPING_PROCESSING: 'shipping_processing',
}


export const VARIANT = {
    PRIMARY: 'primary',
    SECONDARY: 'secondary',
    TERTIARY: 'tertiary',
    OUTLINE: 'outline',
    GRADIENT: 'gradient',
    CUSTOM: 'custom',
    ACTIVE: 'active',
    CUSTOM_MOBILE: 'custom-mobile',
}


export const FIELD_BUSINESS = [
    {code: 1, name: 'Kinh doanh nông sản thô'},
    {code: 2, name: 'Chế biến và kinh doanh sản phẩm từ nông sản'},
    {code: 3, name: 'Kinh doanh giống cây trồng, vật nuôi'},
    {code: 4, name: 'Kinh doanh vật tư nông nghiệp'},
    {code: 5, name: 'Kinh doanh sản phẩm thủy sản'},
    {code: 6, name: 'Kinh doanh lâm sản và sản phẩm từ rừng'},
    {code: 7, name: 'Kinh doanh sản phẩm nông sản hữu cơ, sạch'},
    {code: 8, name: 'Kinh doanh đặc sản vùng miền'},
    {code: 9, name: 'Dịch vụ liên quan đến nông nghiệp'},
    {code: 10, name: 'Kinh doanh sản phẩm thủ công từ nông sản'},
    {code: 11, name: 'Chăn nuôi và cung cấp sản phẩm chăn nuôi'},
    {code: 12, name: 'Kinh doanh phân bón hữu cơ và sản phẩm tái chế từ nông nghiệp'},
    {code: 13, name: 'Khác'}
]

export const ERROR_MESSAGE = {
    ERROR: 'Có lỗi xảy ra. Vui lòng thử lại.',
    ERROR_UPLOAD_FILES: 'Có lỗi xảy ra khi cập nhật Giấy tờ khác',
    ERROR_UPLOAD_AVATAR: 'Có lỗi xảy ra khi cập nhật ảnh đại diện',
}

export const PRODUCT_STATUS = {
    ALL: 'all',
    DRAFT: 'draft',
    PROPOSED: 'proposed',
    PUBLISHED: 'published',
    REJECTED: 'rejected',
    PENDING: 'pending',
}

export const STATUS_TABS = [
    {id: 0, status: PRODUCT_STATUS.ALL, title: "Tất cả", count: 0,},
    {id: 1, status: PRODUCT_STATUS.PUBLISHED, title: "Đang hiển thị", count: 0,},
    {id: 2, status: PRODUCT_STATUS.DRAFT, title: "Đang chờ duyệt", count: 0,},
    {id: 3, status: PRODUCT_STATUS.PROPOSED, title: "Đã ẩn", count: 0,},
    {id: 4, status: PRODUCT_STATUS.REJECTED, title: "Bị từ chối", count: 0,},
];

export const LOCAL_STORAGE_KEY = {
    TOKEN: 'token',
    REFRESH_TOKEN: 'refreshToken',
    CART_STORAGE_KEY: 'selected_cart_items',
    ORDER_STORAGE_KEY: 'order-data'
}

export const CONFIG_URL = {
    POLICY: '/files/dieukhoan.pdf',
    SECURITY: '/files/chinhsach.pdf',
    FUTA_EXPRESS: 'https://futaexpress.vn/',
    FUTA_BUSLINES: 'https://futabus.vn/',
    GOOPAY: 'https://goopay.vn/',
}

export const METADATA_VALUE = {
    YES: 'yes'
}

export const LinkApp = {
    IOS: 'https://apps.apple.com/vn/app/futa-funong/id6738379606',
    ANDROID: 'https://play.google.com/store/apps/details?id=com.futa.funong&pli=1'
}
export const STATUS_ORDERS = [
    {value: 'seller_confirm', name: 'Chờ xác nhận'},
    {value: 'order_created', name: 'Chờ xác nhận'},
    {value: 'system_process', name: 'Chờ xác nhận'},
    {value: 'seller_processing', name: 'Chờ xác nhận'},
    {value: 'seller_prepared', name: 'Chờ xác nhận'},
    {value: 'shipping_processing', name: 'Đang vận chuyển'},
    {value: 'shipping_done', name: 'Giao thành công'},
    {value: 'order_complete', name: 'Giao thành công'},
    {value: 'order_cancel', name: 'Đơn bị huỷ'},
    {value: 'order_refund', name: 'Đơn hoàn/ trả'}
];

export const STATUS_ICONS = {
    'order_created': IconName.documents,
    'seller_confirm': IconName.confirm,
    'seller_prepared': IconName.confirm,
    'shipping_processing': IconName.delivery,
    'shipping_done': IconName.check,
    'order_cancel': IconName.canceled,
    'order_refund': IconName.returned
};
export const STATUS_TITLES = {
    'order_created': 'Chờ xác nhận',
    'seller_confirm': 'Đã xác nhận',
    'seller_prepared': 'Bàn giao cho nhà vận chuyển',
    'shipping_processing': 'Đang vận chuyển',
    'shipping_done': 'Giao hàng thành công',
    'order_cancel': 'Đơn bị huỷ',
    'order_refund': 'Hoàn/Trả hàng'
};


export const CONFIG_IMAGE = {
    MOBILE: {
        HOME: '/img/mobile/Home.png',
        HOME_ACTIVE: '/img/mobile/home-active.png',
        NEWSPAPER: '/img/mobile/Newspaper.png',
        NEWSPAPER_ACTIVE: '/img/mobile/News-active.png',
        STORE: '/img/mobile/store.png',
        USER: '/img/mobile/user.png',
        USER_ACTIVE: '/img/mobile/user-active.png',
        STORE_ACTIVE: '/img/mobile/store.png',
        ABSTRACT: '/img/mobile/abstract.png',
        avatarMobile: '/img/mobile/avatar-mobile.png',
        avatarUserProfile: '/img/mobile/user-profile.png',
        chat: '/img/icon/chat-support.png',
        errorOutline: '/img/mobile/error_outline.svg',
        delivery: '/img/mobile/delivery.svg',
        orderCancel: '/img/mobile/order-cancel.svg',
        orderReturn: '/img/mobile/order-return.svg',
        setup: '/img/mobile/setup.svg',
        shippingDone: '/img/mobile/shipping-done.svg',
    }
}

export const ICON_MOBILE_ORDER_STATUS = {
    'order_created': CONFIG_IMAGE.MOBILE.setup,
    'seller_confirm': CONFIG_IMAGE.MOBILE.setup,
    'seller_prepared': CONFIG_IMAGE.MOBILE.setup,
    'shipping_processing': CONFIG_IMAGE.MOBILE.delivery,
    'shipping_done': CONFIG_IMAGE.MOBILE.shippingDone,
    'order_cancel': CONFIG_IMAGE.MOBILE.orderCancel,
    'order_refund': CONFIG_IMAGE.MOBILE.orderReturn,
}
